// useLocations.js
import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';

import { useState, useEffect, useCallback } from 'react';
import { createContact } from 'services/contact';
import { listContacts } from 'services/Contact/contactServices';
import { totalCountEvent } from 'services/generalServices';

const useLocationsList = () => {
  const { addToast } = useToast();
  const [locationsList, setLocationsList] = useState([]);
  const [isLocationLoading, setIsLocationLoading] = useState(false);

  const loadLocations = useCallback(() => {
    setIsLocationLoading(true);

    totalCountEvent('contact', '', '', '', '', true)
      .then((response) => {
        const obj = {
          contactType: '',
          contactStatus: '',
          keyWord: '',
          is_court_location: true,
          is_event_location: true,
          pageLimit: response.data,
          excludeFromLoading: true,
        };

        return listContacts(obj);
      })
      .then((response) => {
        if (response?.data?.contacts?.length > 0) {
          const options = response.data.contacts.map((item) => ({
            label: item.title || item.office_name,
            value: item.contact_id || item.office_location_id,
          }));
          setLocationsList(options);
        }
      })
      .catch((err) => {
        console.error('Error loading locations:', err);
      })
      .finally(() => setIsLocationLoading(false));
  }, []);

  const handleAddLocation = (title, setToggleLocation, setValue, fieldName) => {
    if (title) {
      let data = {
        contact_type: 'location',
        title: title,
        email: '',
        phone: '',
        country: 'United States',
        country_code: '+1',
      };
      createContact(data)
        .then((response) => {
          const newLocation = {
            label: title || response?.data?.office_name,
            value: response?.data?.contact_id || response?.data?.office_location_id,
          };
          setLocationsList((prev) => [newLocation, ...(prev || [])]);
          addToast(false, toastConstant?.toasterType.SUCCESS, toastConstant?.api.SUCCESS, toastConstant?.message.LOCATION_CREATE_SUCCESS);
          setToggleLocation(false);
          if (setValue && fieldName) {
            setValue(fieldName, newLocation?.value);
          }
        })
        .catch((err) => {
          console.log('err', err);
          addToast(false, toastConstant?.toasterType.ERROR, toastConstant?.api.FAILED, toastConstant?.message.LOCATION_CREATE_FAILURE);
        });
    }
  };

  useEffect(() => {
    loadLocations();
  }, []);

  return {
    locationsList,
    isLocationLoading,
    reloadLocations: loadLocations, // if caller needs to trigger again
    handleAddLocation,
  };
};

export default useLocationsList;
